interface HealthGaugeProps {
  score: number;
  max?: number;
}

function toneColor(pct: number): string {
  if (pct >= 80) return '#15803d';
  if (pct >= 50) return '#b45309';
  return '#b91c1c';
}

/** Circular score gauge built from a CSS conic-gradient — no chart library needed. */
export function HealthGauge({ score, max = 100 }: HealthGaugeProps) {
  const pct = Math.max(0, Math.min(100, (score / max) * 100));
  const color = toneColor(pct);

  return (
    <div
      className="gp-gauge"
      style={{ background: `conic-gradient(${color} ${pct}%, var(--gp-gauge-track) ${pct}%)` }}
      role="img"
      aria-label={`Score ${score} out of ${max}`}
    >
      <div className="gp-gauge__hole">
        <span className="text-[24px] font-bold leading-7 text-text-primary">{Math.round(score)}</span>
        <span className="text-[14px] text-text-secondary">/{max}</span>
      </div>
    </div>
  );
}
